import { inject } from '@angular/core';
import {
    CanActivateFn,
    Router
} from '@angular/router';
import { of } from 'rxjs';

import { AuthService } from '@/auth/services';
import { AppService } from '@/service/app.service';

export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const appService = inject(AppService);
    const router = inject(Router);

    const user = authService.user;

    if (!user) {
        router.navigate(['/login']).then(() => {
            appService.toast('Please login to access this page.', 'warn');
        });
        return of(false);
    }

    const requiredPermissions: string[] = route.data['permissions'] || [];
    if (requiredPermissions.length > 0) {
        const hasAccess = requiredPermissions.every(p => user.permissions?.includes(p));
        if (!hasAccess) {
            router.navigate(['/']).then(() => {
                appService.toast('You do not have permission to access this page.', 'error');
            });
            return of(false);
        }
    }

    return of(true);
};
